var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a-comment",
    fill: "currentColor",
    d: "M27.7 6.8q0-1.5-1.15-2.6-1.05-1.15-2.65-1.15H6.25q-1.65 0-2.7 1.15-1.1 1.1-1.1 2.6v18.95q0 .4.2.65.1.25.45.45.3.2.6.2.35 0 .7-.2l5.65-3.45q.25-.15.7-.15H23.9q1.55 0 2.65-1.1 1.15-1.1 1.15-2.7V6.8m-2.95-.85q.4.35.4.85v12.65q0 .55-.4.9-.35.4-.85.4H10.75q-1.15 0-2 .5l-3.8 2.3V6.8q0-.5.4-.85.35-.35.9-.35H23.9q.5 0 .85.35m-14.7 5.95q-.55 0-.9.4-.4.35-.4.85 0 .55.4.9.35.35.9.35.5 0 .9-.35.35-.35.35-.9 0-.5-.35-.85-.4-.4-.9-.4m5.05 0q-.55 0-.9.4-.4.35-.4.85 0 .55.4.9.35.35.9.35.45 0 .85-.35.35-.35.35-.9 0-.5-.35-.85-.4-.4-.85-.4m5.95 2.15q.35-.35.35-.9 0-.5-.35-.85-.4-.4-.95-.4-.5 0-.85.4-.35.35-.35.85 0 .55.35.9t.85.35q.55 0 .95-.35Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a-comment"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComment);
export default __webpack_public_path__ + "static/media/icon-comment.0dd4b7846ca868d12ef95a3c0448be8a.svg";
export { ForwardRef as ReactComponent };